module.exports = "https://static.wmbcdn.com/uniweb/images/aad39165607e0ea56b4f24a117281cb9.png";